import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { Integrations as TracingIntegrations } from "@sentry/tracing";
import "./index.css";
import "./App.css";
import Root from "./root";
import registerServiceWorker from "./registerServiceWorker";
import { getQueryStringValue } from "./utils/helper";

Sentry.init({
  dsn: "https://6c6b31e5ab7a4501ac62c3385d1f9b73@o915184.ingest.sentry.io/5855143",
  integrations: [
    new TracingIntegrations.BrowserTracing({}),
  ],
  environment: process.env.REACT_APP_SC_ENV === "production" ? "production" : "development",
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.1,
});

require("./utils/polyfills.js");
// registerObserver();
this.userToken = getQueryStringValue("AUTH_TOKEN");
localStorage.setItem("user_token", this.userToken);

ReactDOM.render(Root(), document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js